<div class="gray-overlay" *ngIf="sideDrawerShown" (click)="closeSideDrawer()"></div>

<div class="drawer" [ngStyle]="{ width: sideDrawerShown ? (isMobile ? innerWidth + 'px' : '375px') : '0px' }">
  <div class="drawer-header">
    <h3 class="h3-semibold">Filter</h3>
    <img [src]="iconService.Icon.cross" (click)="closeSideDrawer()" />
  </div>
  <div class="sidebar-scroll">
    <div class="filter" *ngIf="sortingData.length > 0">
      <div class="flex-row" style="justify-content: space-between; margin-bottom: 16px; padding: 0px 24px">
        <p class="p-medium">Sort by</p>
        <p class="clear-button" (click)="clearSorting()">Clear</p>
      </div>
      <div *ngFor="let sort of sortingData">
        <div class="filter-button" (click)="setSort(sort)">
          <p>{{ sort.label }}</p>
          <div style="margin-left: auto; pointer-events: none">
            <app-ag-checkbox-v2 size="small" [initValue]="sort.value" [checked]="sort.value ? 'checked' : 'unchecked'"></app-ag-checkbox-v2>
          </div>
        </div>
      </div>
      <div style="padding: 16px 12px 0 12px">
        <ag-toggle-button
          *ngIf="currentSorting?.value"
          [option1]="currentSorting.ascendingLabel"
          [option2]="currentSorting.descendingLabel"
          [initValue]="currentSorting.currentSorting === 'ascending' ? currentSorting.ascendingLabel : currentSorting.descendingLabel"
          [widthPerOption]="170"
          [initEmit]="false"
          (chosenOption)="sortDirection($event, currentSorting)"></ag-toggle-button>
      </div>
    </div>
    <div class="filter" *ngFor="let filter of filterData">
      @if(getType(filter) === 'checkbox'){
      <div class="flex-row" style="justify-content: space-between; margin-bottom: 16px; padding: 0px 24px">
        <p class="p-medium">{{ filter.title }}</p>
        @if(filter.type === 'checkbox-multiple'){
        <div class="flex-row" style="gap: 8px">
          <p class="clear-button" (click)="selectAll(filter)">Select all</p>

          <p class="clear-button" (click)="resetAll(filter)">Reset</p>
        </div>
        } @else {
        <p class="clear-button" (click)="clearFilter(filter)">Clear</p>
        }
      </div>
      <div class="filter-button" *ngFor="let button of getFiltersWithoutDefault(filter).filter" (click)="filterItem(filter, button)">
        @if(!!button?.imgPath){
        <img [src]="button.imgPath" />
        }
        <p>{{ button.label }}</p>
        <div style="margin-left: auto; pointer-events: none">
          <app-ag-checkbox-v2 size="small" [initValue]="button.value" [checked]="button.value ? 'checked' : 'unchecked'"></app-ag-checkbox-v2>
        </div>
      </div>
      } @else if(getType(filter) === 'spand'){
      <div class="flex-row" style="justify-content: space-between; margin-bottom: 16px; padding: 0px 24px">
        <p class="p-medium">{{ filter.title }}</p>
        <p class="clear-button" (click)="clearFilter(filter)">Clear</p>
      </div>
      <div class="spandOutput">
        <input class="spandInput" type="number" oninput="value = Math.max(value)" [ngClass]="isMinFocused ? 'focused' : ''" [value]="filter.spandMin" (focus)="onFocus('min', filter)" (blur)="onBlur('min', filter)" [placeholder]="'Min. ' + hotelCurrency" (input)="spandInputMin($event, filter)" />
        <p>-</p>
        <input class="spandInput" type="number" oninput="value = Math.max(value)" [ngClass]="isMaxFocused ? 'focused' : ''" [value]="filter.spandMax" (focus)="onFocus('max', filter)" (blur)="onBlur('max', filter)" [placeholder]="'Max. ' + hotelCurrency" (input)="spandInputMax($event, filter)" />
      </div>
      }
    </div>
  </div>

  <div class="drawer-footer">
    <ag-button-v2 label="Clear all" [disabled]="clearAllDisabled()" type="tertiary" size="large" (click)="resetFilter()"></ag-button-v2>
    <ag-button-v2 label="Apply filters" [disabled]="applyDisabled()" type="primary" size="large" (click)="applyFilter()"></ag-button-v2>
  </div>
</div>
